import Endpoints from 'constants/Endpoints';
import {RestRequestBLOB, RestRequestDELETE, RestRequestGET, RestRequestPOST, RestRequestPUT} from 'libs/RestRequest';
import isResponseValid from "../libs/isResponseValid";
import Tr from "../translations/Translations";
import reduxStore from "../redux/store";
import {clearResource, setResource, setSaveStatusClosed, setSaveStatusError, setSaveStatusLoading} from "../redux/actions";
import saveStatus from "constants/status.save";
import AnnualReportStatus from "../pages/purchaser/annualReport/report/constants/AnnualReportStatus";

const ANNUAL_REPORT_TABLES_RESOURCE_ID = "annualReportTables"
const ANNUAL_REPORT_LIST_RESOURCE_ID = "annualReportList"
const ANNUAL_REPORT_RESOURCE_ID = "annualReport"

const getAnnualReportList = async (year) => {
    try {
        const resp = await RestRequestGET(Endpoints.ANNUAL_REPORT_REPORT_YEAR(year));
        reduxStore.dispatch(setResource(ANNUAL_REPORT_LIST_RESOURCE_ID, resp))
    } catch (e) {
        console.error(e);
        showError(Tr('internal_server_error'));
    }
};
const getAnnualReportListAvailableOrgs = async (year) => {
    return await RestRequestGET(Endpoints.ANNUAL_REPORT_REPORT_YEAR_AVAILABLE_ORGS(year));
};
const addAnnualReport = async (data) => {
    return await RestRequestPOST(Endpoints.ANNUAL_REPORT, data);
};
const getAnnualReport = async (reportId) => {
    try {
        const resp = await RestRequestGET(Endpoints.ANNUAL_REPORT_REPORT_ID(reportId));
        if (isResponseValid(resp, showError)) {
            reduxStore.dispatch(setResource(ANNUAL_REPORT_RESOURCE_ID, resp.result))
        }
    } catch (e) {
        console.error(e);
        showError(Tr('internal_server_error'));
    }
};
const getAnnualReportPrevVersions = async (reportId) => {
    try {
        return await RestRequestGET(Endpoints.ANNUAL_REPORT_REPORT_ID_ACTION(reportId, "prevVersions"));
    } catch (e) {
        console.error(e);
        showError(Tr('internal_server_error'));
    }
};
const sendAnnualReportToEzamowienia = async (reportId) => {
    try {
        const resp = await RestRequestPOST(Endpoints.ANNUAL_REPORT_REPORT_ID_ACTION(reportId, "send"));
        await getAnnualReport(reportId);
        return resp;
    } catch (e) {
        console.error(e);
        showError(Tr('internal_server_error'));
    }
};
const submitAnnualReportToEzamowienia = async (reportId) => {
    try {
        const resp = await RestRequestPOST(Endpoints.ANNUAL_REPORT_REPORT_ID_ACTION(reportId, "submit"));
        await getAnnualReport(reportId);
        return resp;
    } catch (e) {
        console.error(e);
        showError(Tr('internal_server_error'));
    }
};
const correctAnnualReportToEzamowienia = async (reportId, year) => {
    try {
        const resp = await RestRequestPOST(Endpoints.ANNUAL_REPORT_REPORT_ID_ACTION(reportId, "correct"));
        if (isResponseValid(resp, showError)) {
            await getAnnualReportList(year);
            return resp;
        }
    } catch (e) {
        console.error(e);
        showError(Tr('internal_server_error'));
    }
};

const downloadAnnualReportPdfFromEzamowienia = async (reportId) => {
    try {
        await RestRequestBLOB(Endpoints.ANNUAL_REPORT_REPORT_ID_ACTION(reportId, "getPdf"))
    } catch (e) {
        console.error(e);
        showError(Tr('internal_server_error'));
    }
};

const initializeTable = async (reportId, formName) => {
    reduxStore.dispatch(setSaveStatusLoading());
    try {
        const resp = await RestRequestPOST(Endpoints.ANNUAL_REPORT_REPORT_ID_INITIALIZE_FORM_NAME(reportId, formName));
        if (isResponseValid(resp, showError)) {
            await getAnnualReportFormValues(reportId, formName);
            markDraft();
            reduxStore.dispatch(setSaveStatusClosed());
        }
    } catch (e) {
        showError(Tr('internal_server_error'));
    }
}
const initializeTableFromPrevVersion = async (reportId, formName) => {
    reduxStore.dispatch(setSaveStatusLoading());
    try {
        const resp = await RestRequestPOST(Endpoints.ANNUAL_REPORT_REPORT_ID_INITIALIZE_FROM_PREV_FORM_NAME(reportId, formName));
        if (isResponseValid(resp, showError)) {
            await getAnnualReportFormValues(reportId, formName);
            markDraft();
            reduxStore.dispatch(setSaveStatusClosed());
        }
    } catch (e) {
        showError(Tr('internal_server_error'));
    }
}

const getAnnualReportTranslations = async () => {
    try {
        const resp = await RestRequestGET(Endpoints.ANNUAL_REPORT_TRANSLATIONS);
        if (isResponseValid(resp, showError)) {
            return resp.result;
        }
    } catch (e) {
        console.error(e);
        showError(Tr('internal_server_error'));
    }
}

const getAnnualReportDictionaries = async () => {
    try {
        const resp = await RestRequestGET(Endpoints.ANNUAL_REPORT_DICTIONARIES);
        if (isResponseValid(resp, showError)) {
            return resp.result;
        }
    } catch (e) {
        console.error(e);
        showError(Tr('internal_server_error'));
    }
}
const getAnnualReportFormValues = async (reportId, formName) => {
    try {
        const resp = await RestRequestGET(Endpoints.ANNUAL_REPORT_REPORT_ID_FORM_NAME(reportId, formName));
        if (isResponseValid(resp, showError)) {
            const {resources} = reduxStore.getState();
            const annualReport = resources[ANNUAL_REPORT_TABLES_RESOURCE_ID] || {};
            reduxStore.dispatch(setResource(ANNUAL_REPORT_TABLES_RESOURCE_ID, {
                ...annualReport,
                [formName]: resp.result
            }))
            return resp.result;
        }
    } catch (e) {
        console.error(e);
        showError(Tr('internal_server_error'));
    }
}

const saveAnnualReportTableEntry = async (reportId, reportStep, data) => {
    try {
        const resp = await RestRequestPOST(Endpoints.ANNUAL_REPORT_REPORT_ID_FORM_NAME(reportId, reportStep), data);
        if (resp.success) {
            const result = resp.result;
            const {resources} = reduxStore.getState();
            const annualReport = resources[ANNUAL_REPORT_TABLES_RESOURCE_ID];
            let form;
            if (data.identity === 0) {
                form = {
                    ...annualReport[reportStep],
                    [result.type]: [...annualReport[reportStep][result.type], result]
                }
            } else {
                const distTypeIndex = annualReport[reportStep][result.type].findIndex(x => x.identity === result.identity);
                if (distTypeIndex !== -1) {
                    form = {
                        ...annualReport[reportStep],
                        [result.type]: annualReport[reportStep][result.type].map(x => x.identity === result.identity ? result : x)
                    }
                } else {
                    const currentType = Object.keys(annualReport[reportStep]).find(key => annualReport[reportStep][key].some(x => x.identity === data.identity));
                    const distType = data.type;
                    let index = annualReport[reportStep][distType].findIndex(x => x.identity > result.identity);
                    if (index === -1) index = annualReport[reportStep][distType].length;
                    const distArr = [...annualReport[reportStep][distType]];
                    distArr.splice(index, 0, result);
                    form = {
                        ...annualReport[reportStep],
                        [currentType]: annualReport[reportStep][currentType].filter((entry) => entry.identity !== data.identity),
                        [distType]: distArr
                    }
                }
            }

            reduxStore.dispatch(setResource(ANNUAL_REPORT_TABLES_RESOURCE_ID, {
                ...annualReport,
                [reportStep]: form
            }))
            markDraft();
        }
        return resp;
    } catch (e) {
        console.error(e);
        showError(Tr('internal_server_error'));
    }
}
const initializeTableEntry = async (reportId, reportStep, currentType, tableIdentity) => {
    try {
        const resp = await RestRequestPOST(Endpoints.ANNUAL_REPORT_REPORT_ID_INITIALIZE_FORM_NAME_TABLE_ID(reportId, reportStep, tableIdentity));
        if (resp.success) {
            const result = resp.result;
            const {resources} = reduxStore.getState();
            const annualReport = resources[ANNUAL_REPORT_TABLES_RESOURCE_ID];
            let form;
            if (currentType === result.type) {
                form = {
                    ...annualReport[reportStep],
                    [result.type]: annualReport[reportStep][result.type].map(x => x.identity === result.identity ? result : x)
                }
            } else {
                const distType = result.type;
                let index = annualReport[reportStep][distType].findIndex(x => x.identity > result.identity);
                if (index === -1) index = annualReport[reportStep][distType].length;
                const distArr = [...annualReport[reportStep][distType]];
                distArr.splice(index, 0, result);
                form = {
                    ...annualReport[reportStep],
                    [currentType]: annualReport[reportStep][currentType].filter((entry) => entry.identity !== result.identity),
                    [distType]: distArr
                }
            }

            reduxStore.dispatch(setResource(ANNUAL_REPORT_TABLES_RESOURCE_ID, {
                ...annualReport,
                [reportStep]: form
            }))
            markDraft();
        }
        return resp;
    } catch (e) {
        console.error(e);
        showError(Tr('internal_server_error'));
    }
}

const deleteAnnualReportTableEntry = async (reportId, tableEntryId, reportStep, currentType) => {
    const data = {
        identity: tableEntryId
    }
    reduxStore.dispatch(setSaveStatusLoading())
    try {
        const resp = await RestRequestDELETE(Endpoints.ANNUAL_REPORT_REPORT_ID_FORM_NAME(reportId, reportStep), {data: data});
        if (isResponseValid(resp, showError)) {
            const {resources} = reduxStore.getState();
            const annualReport = resources[ANNUAL_REPORT_TABLES_RESOURCE_ID];

            const formPart = {
                ...annualReport[reportStep],
                [currentType]: annualReport[reportStep][currentType].filter((entry) => entry.identity !== tableEntryId)
            }

            reduxStore.dispatch(setResource(ANNUAL_REPORT_TABLES_RESOURCE_ID, {
                ...annualReport,
                [reportStep]: formPart
            }))
            markDraft();
            reduxStore.dispatch(setSaveStatusClosed())
            return resp.result;
        }
    } catch (e) {
        showError(Tr('internal_server_error'));
    }
}
const moveAnnualReportTableEntry = async (reportId, tableEntryId, reportStep, currentType, distType) => {
    const data = {
        identity: tableEntryId,
        destination: distType
    }
    reduxStore.dispatch(setSaveStatusLoading())
    try {
        const resp = await RestRequestPUT(Endpoints.ANNUAL_REPORT_REPORT_ID_FORM_NAME(reportId, reportStep), data);
        if (isResponseValid(resp, showError)) {
            const {resources} = reduxStore.getState();
            const annualReport = resources[ANNUAL_REPORT_TABLES_RESOURCE_ID];

            const formPart = {
                ...annualReport[reportStep],
                [currentType]: annualReport[reportStep][currentType].filter((entry) => entry.identity !== tableEntryId),
                [distType]: [...annualReport[reportStep][distType], resp.result]
            }

            reduxStore.dispatch(setResource(ANNUAL_REPORT_TABLES_RESOURCE_ID, {
                ...annualReport,
                [reportStep]: formPart
            }))
            markDraft();
            reduxStore.dispatch(setSaveStatusClosed())
            return resp.result;
        }

    } catch (e) {
        showError(Tr('internal_server_error'));
    }
}


const saveAnnualReportForm = async (reportId, reportStep, data) => {
    try {
        const resp = await RestRequestPOST(Endpoints.ANNUAL_REPORT_REPORT_ID_FORM_NAME(reportId, reportStep), data);
        if (resp.success) {
            const {resources} = reduxStore.getState();
            const annualReport = resources[ANNUAL_REPORT_TABLES_RESOURCE_ID];

            reduxStore.dispatch(setResource(ANNUAL_REPORT_TABLES_RESOURCE_ID, {
                ...annualReport,
                [reportStep]: resp.result
            }))
            markDraft();
        }
        return resp;
    } catch (e) {
        console.error(e);
        showError(Tr('internal_server_error'));
    }
}

const markDraft = () => {
    const {resources} = reduxStore.getState()
    if (resources[ANNUAL_REPORT_RESOURCE_ID] && resources[ANNUAL_REPORT_RESOURCE_ID].status !== AnnualReportStatus.DRAFT) {
        reduxStore.dispatch(setResource(ANNUAL_REPORT_RESOURCE_ID, {...resources[ANNUAL_REPORT_RESOURCE_ID], status: AnnualReportStatus.DRAFT}))
    }
}

const showError = (message) => {
    if (reduxStore.getState().store.saveStatus !== saveStatus.ERROR)
        reduxStore.dispatch(setSaveStatusError(message))
}

const clearResources = (resId) => {
    reduxStore.dispatch(clearResource(resId))
}

export default {
    getAnnualReportList,
    getAnnualReportListAvailableOrgs,
    addAnnualReport,
    getAnnualReport,
    getAnnualReportPrevVersions,
    sendAnnualReportToEzamowienia,
    submitAnnualReportToEzamowienia,
    correctAnnualReportToEzamowienia,
    downloadAnnualReportPdfFromEzamowienia,

    getAnnualReportFormValues,

    //table-based steps
    saveAnnualReportTableEntry,
    moveAnnualReportTableEntry,
    deleteAnnualReportTableEntry,
    initializeTable,
    initializeTableFromPrevVersion,
    initializeTableEntry,

    //single-form steps
    saveAnnualReportForm,

    getAnnualReportDictionaries,
    getAnnualReportTranslations,
    clearResources,
    ANNUAL_REPORT_TABLES_RESOURCE_ID,
    ANNUAL_REPORT_RESOURCE_ID,
    ANNUAL_REPORT_LIST_RESOURCE_ID
}